export const ssnSymbolic = {
    '978': {
        code: 'USA',
        pattern: [3, 5, 9]
    },
    '979': {
        code: 'CANADA',
        pattern: [3, 6, 9]
    },
    '980': {
        code: 'OTHER',
        pattern: []
    }
}